
webpack.register(
    'modules/right-rail/general-schedule/general-schedule',
    function() {
        return import('modules/right-rail/general-schedule/general-schedule');
    },
    true
);